
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.accordion-button{
  display:flex;
  width:100%;
  align-items:baseline;
  justify-content:space-between;
  background-color:var(--brand-neutral-white);
  color:var(--neutral-black);
  font-weight:var(--fw-medium);
  border:unset;
  padding:0.5rem 1rem;
  margin:0.25rem 0;
  font-size:var(--fs-xl);
  position:relative;
}

  .accordion-button:hover{
    color:var(--gray-800);
    background:var(--brand-primary-3);
    cursor:pointer;
  }

  .accordion-button:focus{
    outline:none;
  }

  .accordion-button:focus::after{
      position:absolute;
      left:-4px;
      top:-9px;
      content:'';
      display:flex;
      width:calc(100% + 8px);
      height:calc(100% + 18px);
      border:dotted 2px var(--gray-800);
      border-radius:6px;
      z-index:1;
    }

  @media (max-width: 767px){.accordion-button{
    font-size:var(--fs-lg-mobile)
}
  }

.accordion-button.mobile{
  padding:0.5rem 0;
}

.accordion-content{
  padding:1rem;
}

.accordion-content.mobile{
  padding:1rem 0;
}

.accordion-content.alt{
  padding-top:0;
  border-bottom:0;
}

.accordion-label{
  text-align:left;
  max-width:75%;
}

.accordion-label.alt{
    text-transform:uppercase;
  }

slot[name='heading']{
  font-family:var(--ff-dmsans);
}

.accordion-icon{
  display:flex;
  padding-right:1rem;
  align-self:baseline;
  line-height:normal;
}

.accordion-panel{
  display:flex;
  flex-direction:column;
  border-bottom:solid 1px var(--gray-800);
}

.accordion-panel.alt.active{
    border-bottom:0;
  }

[hidden]{
  display:none !important;
}
`;